<template>
  <div class="course-place text-btn_secondary" :class="{lock: editable && place.lock}">
    <div class="mark-place text-place">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.738007H14V23.738L7 19.965L0 23.738V0.738007Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3H13V4H1V3Z" fill="white"/>
      </svg>
    </div>
    <div class="course-time text-right font-bold">
      <p>{{ routeArrivalTime }}</p>
      <p>{{ nextDepartureTime }}</p>
    </div>
    <div class="course-place-info">
      <div class="course-place-info-inner">
        <div class="course-place-info-number w-6 h-6 ml-1 text-center border font-bold text-white flex-shrink-0">
          {{ routeIndex + 1 }}
        </div>
        <place-icon :place="place" />
        <div class="course-name text-body text-lg leading-5 font-bold break-all">
          {{ place.name }}
        </div>
        <div class="plan-icon ml-1 mr-2">
          <a @click="showMap">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.18746 8.81266L3.40381 10.4691C3.13624 10.5458 2.93311 10.7643 2.87617 11.0367L0.741076 21.2527C0.628783 21.79 1.11277 22.262 1.64707 22.1362L8.62341 20.494C8.73747 20.4671 8.85623 20.4674 8.97017 20.4947L15.1435 21.9751C15.2547 22.0018 15.3705 22.0026 15.4821 21.9777L22.7578 20.3501C23.1599 20.2601 23.4141 19.8625 23.3271 19.4597L21.2569 9.88016C21.1676 9.46677 20.7543 9.20896 20.3438 9.31052L15.3628 10.5427C15.2278 10.5761 15.0861 10.5713 14.9537 10.5288L9.62297 8.81949C9.48167 8.77418 9.33011 8.77181 9.18746 8.81266Z" class="icon-fill" />
            <path d="M9.00002 10L3.75002 11.625L2.06252 20.8125L8.31252 19.3125L9.00002 10Z" fill="white"/>
            <path d="M14.7969 11.5625L9.6875 9.78125L9.125 19.3438L14.7969 20.6094V11.5625Z" fill="white"/>
            <path d="M20.3125 10.5C20.3125 10.5 15.6094 11.5625 15.5469 11.5625V20.7188L21.9844 19.1875L20.3125 10.5Z" fill="white"/>
            <path d="M11.75 1C14.3755 1 16.5 3.11863 16.5 5.73685C16.5 6.3012 16.4351 6.88405 16.1938 7.39289L12.8169 14.5537C12.6221 14.9607 12.1953 15.2105 11.75 15.2105C11.3047 15.2105 10.8779 14.9607 10.6924 14.5537L7.30615 7.39289C7.06494 6.88405 7 6.3012 7 5.73685C7 3.11863 9.12451 1 11.75 1V1ZM11.75 3.36842C10.5107 3.36842 9.5 4.40508 9.5 5.67612C9.5 6.94715 10.5107 7.98381 11.75 7.98381C12.9893 7.98381 14 6.94715 14 5.67612C14 4.40508 12.9893 3.36842 11.75 3.36842V3.36842Z" class="icon-fill" />
            </svg>
          </a>
        </div>
      </div>
      <p class="course-visit text-btn_secondary-lighter mt-1 ml-3">
        {{ visitTime }}
      </p>
    </div>
    <div v-if="editable" class="button-edit relative text-link">
      <place-button :action="toggleEditMenu" :name="$t('tour_edit_label')" />
      <edit-menu
        v-show="showEditMenu"
        :place="place"
        @changeVisit="onChangeVisit"
        @deleteDestination="onDeleteDestination" />
    </div>
  </div>
</template>

<script>
import PlaceIcon from "../atoms/PlaceIcon"
import PlaceButton from "../atoms/PlaceButton"
import EditMenu from "./EditMenu"

export default {
  components: {
    PlaceIcon,
    PlaceButton,
    EditMenu
  },
  props: {
    place: {
      type: Object,
      required: true
    },
    changeVisit: {
      type: Function,
      default: function () {
        return {}
      }
    },
    deleteDestination: {
      type: Function,
      default: function () {
        return {}
      }
    },
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    route: {
      type: Object,
      required: true
    },
    next: {
      type: Object,
      default: function () {
        return {}
      }
    },
    routeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showEditMenu: false
    }
  },
  computed: {
    visitTime: function () {
      const time = this.place.visit
      return `${this.$t('tour_residence_time_label')}：${this.$t('tour_about_label')}` + (time / 60 >= 1 ? Math.floor(time / 60) + this.$t('tour_hour_label') : "") + (time % 60 !== 0 ? time % 60 + this.$t('tour_minute_label') : "");
    },
    routeArrivalTime: function () {
      const t = this.route.arrivalTime
      return t.format("HH:mm")
    },
    nextDepartureTime: function () {
      const t = this.next.departureTime
      return t ? t.format("HH:mm") : ''
    }
  },
  methods: {
    toggleEditMenu: function () {
      this.showEditMenu = !this.showEditMenu
    },
    onChangeVisit: function () {
      this.showEditMenu = false
      this.changeVisit()
    },
    onDeleteDestination: function () {
      this.showEditMenu = false
      this.deleteDestination()
    },
    showMap: function () {
      const location = this.place.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    }
  }
}
</script>
